import { Sheet, SheetContent } from '@/components/ui/sheet';
import { Button } from '@/components/ui/button';
import { X } from 'lucide-react';
import FormDiffusion, { FORM_DIFFUSION_ID } from '../forms/FormDiffusion';
import { useTranslation } from 'react-i18next';

export default function SheetDiffusion({ open, onClose, procedureName = '', companies = [], companyName = '' }) {
    const { t } = useTranslation();
    const handleSubmit = (value) => {
        // TODO: appel API pour sauvegarder les accès de diffusion
        console.log('Diffusion sauvegardée:', value);
        onClose();
    };

    return (
        <Sheet open={open} onOpenChange={(isOpen) => !isOpen && onClose()}>
            <SheetContent showCloseButton={false} className="w-[min(90vw,480px)] flex flex-col p-0 overflow-hidden">
                {/* Header */}
                <div className="flex items-center justify-between p-5 border-b border-border shrink-0">
                    <h2 className="text-[18px] text-foreground leading-tight pr-4">{t('account:diffusion')} {procedureName}</h2>
                    <Button variant="soft" color="neutral" size="xmd" onClick={onClose} className="shrink-0">
                        <X className="h-5 w-5" strokeWidth={1.5} />
                    </Button>
                </div>

                {/* Form (scrollable) */}
                <FormDiffusion
                    key={procedureName}
                    companies={companies}
                    companyName={companyName}
                    initialValue="all"
                    onSubmit={handleSubmit}
                />

                {/* Footer */}
                <div className="border-t border-border p-5 shrink-0">
                    <div className="flex gap-3">
                        <Button
                            variant="soft"
                            color="neutral"
                            size="cta"
                            type="button"
                            className="flex-1"
                            onClick={onClose}
                        >
                            {t('account:annuler')}
                        </Button>
                        <Button
                            variant="solid"
                            color="success"
                            size="cta"
                            type="submit"
                            className="flex-1"
                            form={FORM_DIFFUSION_ID}
                        >
                            {t('account:enregistrer')}
                        </Button>
                    </div>
                </div>
            </SheetContent>
        </Sheet>
    );
}
